module.exports = __webpack_public_path__ + "f5839893023fd53010fb05160c62ded8.png";